module.exports = __webpack_public_path__ + "img/file.ff144e32.svg";